import React from 'react';
import OnboardingLayout from './OnboardingLayout';
import OnboardingStep3 from './step3';

export default class OnboardingStep3Page extends React.Component {
    render() {
        return (
            <OnboardingLayout currentStep={3} totalSteps={5}>
                <OnboardingStep3 />
            </OnboardingLayout>
        );
    }
}
